module.exports = __webpack_public_path__ + "static/media/pdf.49d4041b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/pdf.png
// module id = 507
// module chunks = 0